<template>
  <div>
    <page-header>Лог загрузок</page-header>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mb-60"
      :loading="loading"
      :options.sync="options"
    >
      <template v-slot:item.fileCreateDate="{ item }">
        {{ new Date(item.fileCreateDate * 1000).toLocaleString() }}
      </template>
      <template v-slot:item.fileProcessDate="{ item }">
        {{ new Date(item.fileProcessDate * 1000).toLocaleString() }}
      </template>
      <template v-slot:item.success="{ item }">
        <v-icon :color="item.success ? 'green' : 'red'"
          >mdi-circle-medium</v-icon
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PageHeader from "../components/PageHeader";
import axios from "axios";
import api from "../api";
import store from "../store";

export default {
  name: "Log",
  components: {
    PageHeader
  },
  data() {
    return {
      loading: false,
      options: {},
      items: [],
      headers: [
        {
          text: "Дата скачивания файла",
          value: "fileCreateDate"
        },
        {
          text: "Дата обработки файла",
          value: "fileProcessDate"
        },
        {
          text: "Загружено точек",
          value: "pointsUploaded"
        },
        {
          text: "Загружено полигонов",
          value: "polygonsUploaded"
        },
        {
          text: "Статус обработки",
          value: "success"
        }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.loadItems();
      }
    }
  },
  methods: {
    loadItems() {
      this.loading = true;
      axios
        .get(api.log, {
          params: {
            "per-page":
              this.options.itemsPerPage > 0 ? this.options.itemsPerPage : 1000,
            page: this.options.page
          }
        })
        .then(resp => {
          this.items = resp.data;
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.loadItems();
  }
};
</script>

<style></style>
